export enum PaxDataAction {
  PaxInfo = 'pax-info',
  AddPassport = 'add-passport',
  AddLoyalty = 'add-loyalty',
  LoyaltyInfo = 'loyalty-info',
  Marriott = 'Marriott',
}
